var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrange24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.97031C2 7.47326 2.36494 7.07031 2.81511 7.07031L21.1849 7.07031C21.6351 7.07031 22 7.47326 22 7.97031C22 8.46737 21.6351 8.87031 21.1849 8.87031L2.81511 8.87031C2.36494 8.87031 2 8.46737 2 7.97031Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 16.0307C2 15.5336 2.36494 15.1307 2.81511 15.1307L21.1849 15.1307C21.6351 15.1307 22 15.5336 22 16.0307C22 16.5277 21.6351 16.9307 21.1849 16.9307L2.81511 16.9307C2.36494 16.9307 2 16.5277 2 16.0307Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrange24);
export default __webpack_public_path__ + "static/media/arrange-24.956017143c082342f04b3fa6fccd631c.svg";
export { ForwardRef as ReactComponent };